<template>
  <article>
    <upload-pic
      :images.sync="positionList"
      @upload="batchUpload"
      @delete="deleteImages">
      <p class="title">16张照片为必填项 <br />
      建议在对应的位置上传以下照片(可拖动照片交换位置),“其他”照片可上传车辆功能亮点或者加装改装配置或者高低配置差别部位的照片(如天窗,加热,电动座椅,音响,电尾)等。</p>
    </upload-pic>
    <section class="btn-bottom submit-btn">
      <div class="btn-fix">
        <a class="btn" @click.stop="toSave()">保存</a>
        <!--<a class="btn" @click.stop="batchUpload()">批量上传</a>-->
      </div>
    </section>
  </article>
</template>
<script>
import cache from '../../../common/cache'
import { photo } from './restConfig'
import { UploadPic } from '@lx-frontend/cvux'
import bgLeft from '../../../stylesheets/images/manage/photo/left.jpg'
import bgLeftFront from '../../../stylesheets/images/manage/photo/left_front.jpg'
import bgFrontChair from '../../../stylesheets/images/manage/photo/front_chair.jpg'
import bgDashboard from '../../../stylesheets/images/manage/photo/dashbord.jpg'
import bgBackChair from '../../../stylesheets/images/manage/photo/back_chair.jpg'
import bgCentralControlBoard from '../../../stylesheets/images/manage/photo/central_control_board.jpg'
import bgEnd from '../../../stylesheets/images/manage/photo/end.jpg'
import bgTrunkBottom from '../../../stylesheets/images/manage/photo/trunk_bottom.jpg'
import bgRightEnd from '../../../stylesheets/images/manage/photo/right_end.jpg'
import bgEngineCompartment from '../../../stylesheets/images/manage/photo/engine_compartment.jpg'
import bgFactoryNameplate from '../../../stylesheets/images/manage/photo/factory_nameplate.jpg'

export default {
  components: {
    UploadPic
  },
  data() {
    return {
      id: 0,
      source: '',
      isHandle: false,
      positionList: [
        { src: '', name: '左前方', code: 'left_front', bgUrl: bgLeftFront },
        { src: '', name: '左侧', code: 'left', bgUrl: bgLeft },
        { src: '', name: '前排座椅', code: 'front_chair', bgUrl: bgFrontChair },
        { src: '', name: '仪表盘', code: 'dashboard', bgUrl: bgDashboard },
        { src: '', name: '后排座椅', code: 'back_chair', bgUrl: bgBackChair },
        { src: '', name: '中控板', code: 'central_control_board', bgUrl: bgCentralControlBoard },
        { src: '', name: '车尾', code: 'end', bgUrl: bgEnd },
        { src: '', name: '后备箱底板', code: 'trunk_bottom', bgUrl: bgTrunkBottom },
        { src: '', name: '右后方', code: 'right_end', bgUrl: bgRightEnd },
        { src: '', name: '发动机舱', code: 'engine_compartment', bgUrl: bgEngineCompartment },
        { src: '', name: '出厂铭牌', code: 'factory_nameplate', bgUrl: bgFactoryNameplate },
        { src: '', name: '其他', code: 'other_1' },
        { src: '', name: '其他', code: 'other_2' },
        { src: '', name: '其他', code: 'other_3' },
        { src: '', name: '其他', code: 'other_4' },
        { src: '', name: '其他', code: 'other_5' }
      ]
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.source = this.$route.params.source
    if (this.id) {
      let urlLeft = photo[this.source](this.id)
      this.$rest.carInfo.query(null, urlLeft).then((res) => {
        if (res.code === 0) {
          let serverImages = res.data.images
          // todo 缺第一次单张照片上传处理
          serverImages.forEach(v => {
            this.positionList.find((t) => {
              if (v.position_code === t.code) t.src = v.image_url
            })
          })
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  methods: {
    deleteImages(i) {
      this.positionList[i].src = ''
      this.sendImagesToServer()
    },
    sendImagesToServer() {
      let imagesFrom = {}
      // 上传图片keyde格式: ***_image_url
      this.positionList.forEach((v, i) => {
        let imgUrl = this.positionList[i].src
        if (imgUrl) imagesFrom[`${v.code}_image_url`] = imgUrl
      })
      this.$rest.carInfo.create(imagesFrom, photo[this.source](this.id)).then((res) => {
        if (res.code === 0) {
          if (this.isHandle) {
            let ticketId = cache.getSessionData('CAR_INFO_TICKET_ID') || ''
            let query = ticketId && `?ticketId=${ticketId}`
            this.$router.push(`/auction/carInfo/edit/${this.id}/${this.source}${query}`)
            this.isHandle = false
            this.showToast('保存成功')
          }
        } else {
          this.showToast(res.message)
        }
      })
    },
    batchUpload(index) {
      let iamges = this.positionList
      this.$wechat.batchImgUpload(this, index, iamges, 'getImageByAuctionInBatch', 16)
    },
    toSave() {
      this.isHandle = true
      this.sendImagesToServer()
    }
  }
}

</script>
<style lang="less">
.upload_pic_list {
  background:#fff;
}
</style>
